import "./index.scss";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Nav = () => {
  const location = useLocation();

  const isMob = false;

  const navElement = [
    {
      href: "/app/main",
      title: "Отчет",
    },
    {
      href: "/app/applications",
      title: "Заявки",
    },
    {
      href: "/app/leads",
      title: "Лиды",
    },
    {
      href: "/app/customers",
      title: "Клиенты",
    },
    {
      href: "/app/catalogs",
      title: "База компаний",
    },
  ];
  return (
    <ul className={`navbar ${isMob ? "navbar_mob" : ""}`}>
      {navElement.map((item) => (
        <li className="navbar__item">
          <Link
            className={`navbar__link ${
              location.pathname.includes(item.href) ? "active" : ""
            }`}
            to={item.href}
          >
            {item.title}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default Nav;
